import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML, encodeHTML } from "@utils/CommonUtils";
import { useEffect, useState } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { useAuth } from "~/Hooks/useAuth";
import { post, put } from "~/Services";
import { corporateHost, eramanApiURL, magpHost } from "~/Utils";
import { fields, fieldsReady } from "../constants";
import { useAirlinesDocumentDetails } from "./Airlines.hook";

export const AddEditAirlines = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const { user } = useAuth();
  const [fieldData, setFieldData] = useState<any>();

  async function fetchData() {
    await fieldsReady;
    setFieldData(fields);
  }

  useEffect(()=>{
    fetchData();
  },[])

  const {
    data: editData,
    error,
    isLoading: drilldownLoading,
    isError,
    refetch: refetchEditData,
  } = useAirlinesDocumentDetails(query.get("editId") || "");

  const {
    data: dataById,
    isLoading: isLoadingData,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    if (query.get("id")) {
      refetchDocument();
    }
    if (query.get("editId")) {
      refetchEditData();
    }
  }, [query.get("editId"), query.get("id")]);

  const AwardsFormConfig: FormConfig = {
    initialValues: {
        published: dataById ? decodeHTML(dataById.payload?.published) : editData ? decodeHTML(editData?.published) : false,
        title: dataById
            ? decodeHTML(dataById.payload.title)
            : editData
            ? decodeHTML(editData?.title)
            : "",
        field_agency_title_ms: dataById ? decodeHTML(dataById.payload.field_agency_title_ms) : editData ? decodeHTML(editData?.field_agency_title_ms) : "",
        field_agency_title_zh: dataById
            ? decodeHTML(dataById.payload.field_agency_title_zh)
            : editData
            ? decodeHTML(editData?.field_agency_title_zh)
            : "",
        field_agency_image: dataById?.payload
        ? decodeHTML([
            {
              uid: "-1",
              name: "field_agency_image.png",
              status: "done",
              url: dataById?.payload?.field_agency_image,
            },
          ])
        : decodeHTML([
            {
              uid: "-1",
              name: "field_agency_image.png",
              status: "done",
              url: editData?.field_agency_image,
            },
          ]),
        field_agency_link_en: dataById ? decodeHTML(dataById.payload.field_agency_link_en) : editData ? decodeHTML(editData?.field_agency_link_en) : "",
        field_agency_link_ms: dataById ? decodeHTML(dataById.payload.field_agency_link_ms) : editData ? decodeHTML(editData?.field_agency_link_ms) : "",
        field_agency_link_zh: dataById ? decodeHTML(dataById.payload.field_agency_link_zh) : editData ? decodeHTML(editData?.field_agency_link_zh) : "",
        field_agency_order_sequence: dataById ? decodeHTML(dataById.payload.field_agency_order_sequence) : editData ? decodeHTML(editData?.field_agency_order_sequence) : "",

        
    },
    fields: fieldData?.airlines,
  };

  console.log("trainingFacilities", AwardsFormConfig.fields, AwardsFormConfig.initialValues);

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    let imageKeys: any = [
      "field_agency_image"
    ];
    for (const key of imageKeys) {
      try {
        let field = data[key];
        if (field[0].originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "CORPORATE");
          const res: any = await post("management/upload-file", formData);

          if (res) {
            data[key] = res.response.data;
          }
        } else {
          data[key] = data[key][0].url;
        }
      } catch (error) {}
    }
    const payload = {
      action: action,
      method: method,
      module: "Stake Holders",
      subModule: "airlines",
      type: "DEDICATED",
      application: "MAHB_CORPORATE",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "MAHB_CORPORATE",
          apiUrl: apiUrl,
        },
      ],
      moduleKey: "MAHB_CORPORATE_Stake Holders_Airlines",
      payload: {
        ...(action === 'UPDATE' && { id: editData?.id || dataById?.payload?.id }),
        ...data,
        field_agency_page_en: editData?.field_agency_page_en || dataById?.payload?.field_agency_page_en || "airlines",
        field_agency_page_ms: editData?.field_agency_page_ms || dataById?.payload?.field_agency_page_ms || "airlines",
        field_agency_page_zh: editData?.field_agency_page_zh || dataById?.payload?.field_agency_page_zh || "airlines",
      },
      status: status,
    };
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response:any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === 'OK' && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else{
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response:any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === 'OK' && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else{
            navigate("/dedicated/status-information?activeTab=draft");
          }
          // refetchDocument();
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <ContentWrapper
      // loading={isLoadingData}
      title={`${query.get("id") || query.get("editId") ? "Edit" : "Add New"} Airlines`}
      showBack
    >
      <DynamicForm
        isLoading={isLoadingData || drilldownLoading}
        config={AwardsFormConfig}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            query.get("editId") || query.get("type") === "update"
              ? `${corporateHost}/api/agency-data/${editData?.id || dataById?.payload?.id}`
              : `${corporateHost}/api/create/aagency-data`,
            query.get("editId") || query.get("type") === "update" ? "UPDATE" : "CREATE",
            query.get("editId") || query.get("type") === "update" ? "PATCH" : "POST",
            buttonValue === "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        } 
        defaultReviewNotes="Kindly review this Stake Holders"         
      />
    </ContentWrapper>
  );
};
